const INDIA_LAT = { min: 6, max: 37 };
const INDIA_LNG = { min: 68, max: 100 };

const toNumber = (value) => {
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};

export const toLngLat = (coord) => {
  if (coord && typeof coord === "object" && !Array.isArray(coord)) {
    const lat =
      coord.lat ?? coord.latitude ?? coord.Lat ?? coord.Latitude ?? null;
    const lng =
      coord.lng ??
      coord.longitude ??
      coord.lon ??
      coord.Lng ??
      coord.Longitude ??
      null;

    if (lat != null && lng != null) {
      return toLngLat([lat, lng]);
    }

    return null;
  }

  if (!Array.isArray(coord) || coord.length < 2) return null;

  const first = toNumber(coord[0]);
  const second = toNumber(coord[1]);
  if (first == null || second == null) return null;

  const firstIsLat = first >= INDIA_LAT.min && first <= INDIA_LAT.max;
  const secondIsLng = second >= INDIA_LNG.min && second <= INDIA_LNG.max;
  const firstIsLng = first >= INDIA_LNG.min && first <= INDIA_LNG.max;
  const secondIsLat = second >= INDIA_LAT.min && second <= INDIA_LAT.max;

  // Already [lng, lat]
  if (firstIsLng && secondIsLat) {
    return [first, second];
  }

  // API sends [lat, lng]
  if (firstIsLat && secondIsLng) {
    return [second, first];
  }

  // Default to API contract: [lat, lng]
  return [second, first];
};
